import { api } from "@/lib/api";
import type { Team, TeamLeaderboardEntry, TeamMember } from "@/types";

export async function getTeams(competitionId: string): Promise<Team[]> {
  const res = await api.get<Team[]>(`/competitions/${competitionId}/teams`);
  if (res.error) throw res.error;
  return res.data;
}

export async function createTeam(competitionId: string, name: string): Promise<Team> {
  const res = await api.post<Team>(`/competitions/${competitionId}/teams`, { name });
  if (res.error) throw res.error;
  return res.data;
}

export async function getTeam(
  competitionId: string,
  teamId: string,
): Promise<Team & { members: TeamMember[] }> {
  const res = await api.get<Team & { members: TeamMember[] }>(
    `/competitions/${competitionId}/teams/${teamId}`,
  );
  if (res.error) throw res.error;
  return res.data;
}

export async function disbandTeam(competitionId: string, teamId: string): Promise<void> {
  const res = await api.delete(`/competitions/${competitionId}/teams/${teamId}`);
  if (res.error) throw res.error;
}

export async function joinTeam(competitionId: string, teamId: string): Promise<void> {
  const res = await api.post(`/competitions/${competitionId}/teams/${teamId}/join`);
  if (res.error) throw res.error;
}

export async function leaveTeam(competitionId: string, teamId: string): Promise<void> {
  const res = await api.post(`/competitions/${competitionId}/teams/${teamId}/leave`);
  if (res.error) throw res.error;
}

export async function inviteToTeam(
  competitionId: string,
  teamId: string,
  userId: string,
): Promise<void> {
  const res = await api.post(`/competitions/${competitionId}/teams/${teamId}/invite`, {
    targetUserId: userId,
  });
  if (res.error) throw res.error;
}

export async function removeFromTeam(
  competitionId: string,
  teamId: string,
  userId: string,
): Promise<void> {
  const res = await api.post(`/competitions/${competitionId}/teams/${teamId}/remove-member`, {
    targetUserId: userId,
  });
  if (res.error) throw res.error;
}

export async function transferCaptain(
  competitionId: string,
  teamId: string,
  userId: string,
): Promise<void> {
  const res = await api.post(`/competitions/${competitionId}/teams/${teamId}/transfer-captain`, {
    targetUserId: userId,
  });
  if (res.error) throw res.error;
}

export async function getTeamLeaderboard(competitionId: string): Promise<TeamLeaderboardEntry[]> {
  const res = await api.get<TeamLeaderboardEntry[]>(
    `/competitions/${competitionId}/team-leaderboard`,
  );
  if (res.error) throw res.error;
  return res.data;
}
